// Token de la tablet del stand. Se obtiene UNA VEZ por dispositivo con el PIN
// y viaja en cada llamada del stand.
//
// No vence: requireStaff lo compara contra STAND_TOKEN del .env, sin fecha. La
// tablet queda armada hasta que alguien la desarma o el navegador borra sus
// datos (limpiar datos del sitio, modo incógnito, otro navegador).
//
// Es el mismo valor para todas las tablets: cambiar STAND_TOKEN en el servidor
// desarma TODAS a la vez.
const KEY = 'cvdl_stand_token';

export function getStandToken() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function setStandToken(token) {
  try { localStorage.setItem(KEY, token); } catch { /* modo privado */ }
}

export function clearStandToken() {
  try { localStorage.removeItem(KEY); } catch { /* modo privado */ }
}
